// AppsFlyer in-app events.
//
// QUSHi's mobile app is this React app running inside a Flutter WebView, so the
// AppsFlyer SDK lives on the NATIVE side: the web layer only names the event and
// the shell logs it. On plain web there is no shell, so we also hand the event
// to AppsFlyer's own Web SDK global if the page happens to carry that tag.
//
// Both transports are guarded, so with neither present this is a silent no-op —
// which is the state today: the AppsFlyer keys and the native handler are still
// to come from the client. Wiring the call sites now means only this one file
// changes when they land.
//
// Nothing in here throws. An analytics call must never break the interaction
// it is measuring.
import { event } from "./event";

// Event names are declared here rather than typed at the call site, so the exact
// string the client set up in AppsFlyer can't drift or be misspelled.
export const AF_EVENTS = {
  CASH_GAME_NOTIFY_TAP: "cash_game_notify_tap",
};

// AppsFlyer is attribution, which is an advertising purpose, so it follows the
// advertising consent state (QushiPrivacy.consentState): denied in prior-consent
// regions until the visitor accepts, and denied anywhere once advertising is
// turned off in Privacy Choices or the sale/share opt-out or GPC is on.
const advertisingAllowed = () => {
  try {
    const P = typeof window !== "undefined" ? window.QushiPrivacy : null;
    if (!P) return false;
    return P.consentState(P.read()).ad_storage === "granted";
  } catch (e) {
    return false;
  }
};

export const logAppsFlyerEvent = (eventName, eventValue = {}) => {
  if (!eventName) return;
  if (!advertisingAllowed()) return;

  try {
    // In-app: the Flutter shell owns the SDK. `event()` already no-ops when the
    // WebView bridge isn't there, so this costs nothing on the web.
    event("appsflyer_event", { eventName, eventValue });

    // Web: AppsFlyer's PBA tag, only if it's actually on the page.
    if (typeof window !== "undefined" && typeof window.AF === "function") {
      window.AF("pba", "event", { eventType: "EVENT", eventName, eventValue });
    }
  } catch (e) {
    // Swallow — a failed measurement must not take the tap with it.
    console.error("AppsFlyer event failed:", eventName, e);
  }
};
